import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { persistStore } from 'redux-persist';
import reducers from '../redux/index';
import rootSagas from "../sagas";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware()
const store = createStore(reducers,
  composeEnhancers(applyMiddleware(sagaMiddleware))
    )
    const persistor = persistStore(store);
sagaMiddleware.run(rootSagas)


export { store, persistor };